import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { round } from '@src/utils/functions/utils'
import classnames from 'classnames'

import useScrollAnimation from '../../hooks/useScrollAnimation'
import { RichText, RichTextProps } from '../../molecules'
import Button, { ButtonProps } from '../button'
import { Image, ImageProps } from '../image'
import Swiper from '../swiper'

import styles from './featureSectionFive.module.scss'

export interface FeatureSectionFiveProps {
  topLeftImageProps: ImageProps
  topRightImageProps: ImageProps
  sliderImage: ImageProps
  headingRichTextProps?: RichTextProps
  subHeadingRichTextProps?: RichTextProps
  descriptionRichTextProps?: RichTextProps
  buttonProps?: ButtonProps
}

const addAnimation = (element: HTMLElement, percentagePassed: number) => {
  // @i18n-ignore
  element.style.transform = `rotate(${round(percentagePassed * 45, 3)}deg)`
}

const animationOptions = {
  completeOffsetPercentage: 0.25,
}

export const FeatureSectionFive = (props: FeatureSectionFiveProps) => {
  const deviceInfo = useDeviceInfo()

  const ref = useScrollAnimation<HTMLDivElement>(addAnimation, animationOptions)

  return (
    <div className={styles.section_wrap}>
      {deviceInfo.deviceType === DEVICE_TYPES.DESKTOP && (
        <div className={classnames(styles.section_wrap_top, 'mobileOnly')}>
          <Swiper variableWidth id={'feature-section-five-carousal'}>
            {props.topLeftImageProps.url && (
              <Image
                alt={props.topLeftImageProps.alt}
                {...props.topLeftImageProps}
                className={classnames(props.topLeftImageProps.className, 'padding-right--22', styles.imageLeftMobile)}
              />
            )}
            {props.topRightImageProps.url && (
              <Image
                alt={props.topRightImageProps.alt}
                {...props.topRightImageProps}
                className={classnames(props.topRightImageProps.className, 'padding-right--22', styles.imageRightMobile)}
              />
            )}
          </Swiper>
          {props.headingRichTextProps && (
            <div className={styles.heading_wrap}>
              <RichText
                {...props.headingRichTextProps}
                className={classnames(styles.heading, props.headingRichTextProps.className)}
              />
            </div>
          )}
        </div>
      )}
      {deviceInfo.deviceType === DEVICE_TYPES.DESKTOP && (
        <div className={classnames(styles.section_wrap_top, 'desktopOnly')}>
          <div className={styles.section_wrap_top__left}>
            {props.topLeftImageProps.url && (
              <Image
                alt={props.topLeftImageProps.alt}
                ref={ref}
                {...props.topLeftImageProps}
                className={styles.topLeftImage}
              />
            )}
          </div>
          <div className={styles.section_wrap_top__right}>
            <div className={styles.right_img}>
              {props.topRightImageProps.url && (
                <Image
                  alt={props.topRightImageProps.alt}
                  {...props.topRightImageProps}
                  className={styles.topRightImg}
                />
              )}
            </div>
            {props.headingRichTextProps && (
              <div className={styles.heading_wrap}>
                <RichText
                  {...props.headingRichTextProps}
                  className={classnames(styles.heading, props.headingRichTextProps.className)}
                />
              </div>
            )}{' '}
          </div>
        </div>
      )}
      <div className={styles.section_wrap_bottom}>
        <div className={styles.section_wrap_bottom__left}>
          {props.sliderImage.url && (
            <Image alt={props.sliderImage.alt} {...props.sliderImage} className={styles.sliderImageItem} />
          )}
        </div>
        <div className={styles.section_wrap_bottom__right}>
          <div className={styles.bottom_right}>
            {props.subHeadingRichTextProps && (
              <RichText
                {...props.subHeadingRichTextProps}
                className={classnames(styles.bottom_right__heading, props.subHeadingRichTextProps.className)}
              />
            )}
            {props.descriptionRichTextProps && (
              <RichText
                {...props.descriptionRichTextProps}
                className={classnames(styles.bottom_right__description, props.descriptionRichTextProps.className)}
              />
            )}
            {props.buttonProps && (
              <Button
                {...props.buttonProps}
                className={classnames(props.buttonProps.className, styles.leftContentInner__button)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeatureSectionFive
